<template lang="html">
	<div :class='locked ? "Pager locked" : "Pager"'>
		<div @click='merge()' :class='current == total ? "more disabled" : "more"'>
			<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 561 561" style="enable-background:new 0 0 561 561;" xml:space="preserve">
				 <g>
					<path d="M280.5,76.5V0l-102,102l102,102v-76.5c84.15,0,153,68.85,153,153c0,25.5-7.65,51-17.85,71.4l38.25,38.25
						C471.75,357,484.5,321.3,484.5,280.5C484.5,168.3,392.7,76.5,280.5,76.5z M280.5,433.5c-84.15,0-153-68.85-153-153
						c0-25.5,7.65-51,17.85-71.4l-38.25-38.25C89.25,204,76.5,239.7,76.5,280.5c0,112.2,91.8,204,204,204V561l102-102l-102-102V433.5z"
						/>
				</g>
			</svg>
				<slot></slot>
		</div>

		<!-- <div>{{ chunks }}</div>
		<div>{{ current_chunk }}</div> -->

		<div class="pager">

			<span :class='current == 1 ? "prev disabled" : "prev"' @click='prev()'>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left">
					<line x1="20" y1="12" x2="4" y2="12"></line>
					<polyline fill="none" points="10 18 4 12 10 6"></polyline>
				</svg>
			</span>

			<template v-if='total <= numOfVisible * 2'>
				<template v-for='page in total'>
					<span :class='page == current ? "active" : false' @click='goto(page)'>{{ page }}</span>
				</template>
			</template>

			<template v-else>
				<template v-if='showFirst'>
					<span @click='goto(1)'>1</span>
					<span @click='goto(chunks[currentChunkIndex - 1][chunks[currentChunkIndex - 1].length - 1])'>...</span>
				</template>

				<template v-if='!end'>
					<!-- з початку -->
					<template v-for='page in current_chunk'>
						<span :class='page == current ? "active" : false' @click='goto(page)'>{{ page }}</span>
					</template>
				</template>

				<template v-else>
					<!-- з кінця -->
					<template v-for='page in current_chunk'>
						<span :class='page == current ? "active" : false' @click='goto(page)'>{{ page }}</span>
					</template>
				</template>

				<template v-if='showLast'>
					<span @click='goto(chunks[currentChunkIndex + 1][0])'>...</span>
					<span @click='goto(total)'>{{ total }}</span>
				</template>
			</template>

			<span :class='current == total ? "next disabled" : "next"' @click='next()'>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left">
					<line x1="20" y1="12" x2="4" y2="12"></line>
					<polyline fill="none" points="10 18 4 12 10 6"></polyline>
				</svg>
			</span>

		</div>
	</div>
</template>

<script>
module.exports = {
	props: ['total', 'current', 'locked'],

	data() {
		return {
			numOfVisible: 3,
			end: false,
			showFirst: false,
			showLast: false,
			currentChunkIndex: null
		}
	},

	computed: {
		chunks() {
			let a = [];
			let b = [];

			if(this.total) {
				for(let i = 1; i <= this.total; i++) {
					if(i % this.numOfVisible == 0) {
						b.push(i);
						a.push(b);
						b = [];
					}
					else {
						b.push(i);
					}
				}

				if(b.length) {
					a.push(b);
				}
			}

			return a;
		},

		current_chunk() {
			let result = null;

			if(this.total && this.current) {
				let begining_of_the_end = this.total - this.numOfVisible;
				// console.log(begining_of_the_end);

				if(this.current >= begining_of_the_end) {
					this.end = true;
					this.showFirst = true;

					let stop = false;
					for(let i = 0; i < this.chunks.length; i++) {
						for(let j = 0; j < this.chunks[i].length; j++) {
							if(this.chunks[i][j] == this.current) {
								result = this.chunks[i];
								stop = true;
								this.currentChunkIndex = i;

								if(this.chunks[i + 1]) {
									if(this.chunks[i + 1].length == 1) {
										result = result.concat(this.chunks[i + 1]);
										this.showLast = false;
									}
									else {
										this.showLast = true;
									}
								}
								else {
									this.showLast = false;
								}

								break;
							}
							if(stop) break;
						}
					}
				}
				else {
					this.end = false;
					this.showFirst = false;
					this.showLast = true;

					let stop = false;
					for(let i = 0; i < this.chunks.length; i++) {
						for(let j = 0; j < this.chunks[i].length; j++) {
							if(this.chunks[i][j] == this.current) {
								result = this.chunks[i];
								stop = true;
								this.currentChunkIndex = i;

								if(i > 0) {
									this.showFirst = true;
								}
								break;
							}
							if(stop) break;
						}
					}
				}
			}

			return result;
		}
	},

	methods: {
		prev() {
			this.$emit('goto', 'prev');
		},
		next() {
			this.$emit('goto', 'next');
		},
		merge() {
			this.$emit('goto', 'merge');
		},
		goto(n) {
			this.$emit('goto', n);
		}
	},
}
</script>

<style lang="scss">
@import "scss/wanted";

@keyframes loading {
	from {
		@include rotate(0deg);
	}
	to {
		@include rotate(-360deg);
	}
}

.Pager {
	@include single-transition;
	@include pointer-events(auto);

	&.locked {
		opacity: .4;
		@include pointer-events(none);

		.more {

			svg {
				@include animation(loading 1000ms cubic-bezier(.3,.43,.45,.87) 0ms normal infinite both running);
			}
		}
	}

	.more {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;
		height: rem(48);
		text-align: center;
		text-decoration: none;
		cursor: pointer;
		border: none;
		outline: none;
		margin: 0 auto 31px;
		user-select: none;
		@include single-transition();
		font-weight: 900;
		letter-spacing: 0;
		font-size: 16px;
		color: #21293b;
		width: 190px;
		background-color: transparent;
		border: 1px solid #21293b;
		// box-shadow: 0px 5px 30px 0px rgba(#000, 0.4);
		// text-transform: uppercase;
		border-radius: 30px;
		svg {
			fill: #21293b;
			height: rem(23);
			width: auto;
			margin: 0 rem(15) 0 0;
			flex-basis: 24px;
			@include single-transition();
			@include animation(loading 1000ms cubic-bezier(.3,.43,.45,.87) 0ms normal infinite both paused);
		}
		&.hover, &.active {
			pointer-events: none;
		}

		&:hover, &.hover {
			background-color: #21293b;
			color: #fff;
			svg{
				fill: #fff;
			}
		}

		&:active, &.active{
			background-color: #21293b;
			color: #fff;
			svg{
				fill: #fff;
			}
		}

		&.disabled {
			opacity: .5;
			@include pointer-events(none);
		}


	}

	.pager{
		display: flex;
		justify-content: center;
		margin-bottom: rem(25);
		@include m___up{
			margin-bottom: rem(42);
		};

		span{
			display: flex;
			align-items: center;
			justify-content: center;
			width: 36px;
			height: 36px;
			border: 1px solid transparent;
			text-align: center;
			text-decoration: none;
			font-size: 14px;
			letter-spacing: .075em;
			color: #21293b;
			border-radius: 100%;
			line-height: 36px;
			cursor: pointer;
			@include single-transition;

			svg{
				fill: transparent;
				width: 20px;
				@include single-transition;
			}
			&.next{
				svg{
					transform: rotate(180deg);
				}
			}
			&.next, &.prev {
				border-color: #21293b;
				margin: 0 5px;
				&:hover{
					border-color: #21293b;
				}

				&.disabled {
					opacity: .3;
					@include pointer-events(none);
				}
			}

			&:hover{
				color: #fff;
				background-color: #21293b;
				svg{
					fill: #fff;
				}
			}

			&.active {
				font-weight: 900;
				color: #21293b;
				pointer-events: none;
				&:hover{
					color: #fff;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// Pager.vue?711a9d5a